/**
 * Copyright 2025 Nordcloud Oy or its affiliates. All Rights Reserved.
 */

import { statusDetails } from "./const";
import { ResourceUpdateStatus } from "./types";

export const getUpdateStatusDetails = (status: ResourceUpdateStatus) =>
  statusDetails[status];
